<template>
  <z-expansion-config-item 
    titulo="Cliente Padrão do Sistema" 
    subtitulo="Selecione o cliente padrão do sistema na venda"
  >
    <v-autocomplete
      v-model="store.configuracoes.CLIENTE_PADRAO"
      dense
      filled
      hide-details
      style="width: 300px"
      :items="clientes"
      @change="updateConfig"
    ></v-autocomplete>
  </z-expansion-config-item>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useConfigStore } from '@/app/store/pinia/configuracoes'

import listasApi from '@/app/services/listas'

const store = useConfigStore();
const clientes = ref([]);

onMounted(async () => {
  const clientes_response = await listasApi.clientes();
  
  clientes.value = clientes_response.map((cliente) => {
    return {
      text: cliente.id + ' - ' + cliente.razao,
      value: cliente.id,
    };
  });
});

function updateConfig() {
  store.salvarConfiguracao({
    config: 'CLIENTE_PADRAO',
    valor: store.configuracoes.CLIENTE_PADRAO,
    tipo: 'integer',
    descricao: 'Cliente Padrão do Sistema',
    ajuda: 'Selecione o cliente padrão do sistema na venda'
  });
}

</script>

<style lang="scss" scoped>

</style>
